import Layout from '@/layout'

const adminRouter = {
  path: '/admin',
  component: Layout,
  redirect: 'noRedirect',
  meta: {
    title: '超级管理员'
  },
  children: [{
    path: 'products',
    component: () => import('@/views/admin/products'),
    name: 'AdminProducts',
    meta: {
      title: '参赛作品',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'productAwards',
    component: () => import('@/views/admin/productAwards'),
    name: 'AdminProductAwards',
    meta: {
      title: '获奖作品',
      icon: 'cansaizuopin'
    }
  },
  // {
  //   path: 'publicTransfer',
  //   component: () => import('@/views/admin/publicTransfer'),
  //   name: 'AdminPublicTransfer',
  //   meta: {
  //     title: '对公转账',
  //     icon: 'publicTransfer'
  //   }
  // },
  {
    path: 'record',
    component: () => import('@/views/admin/record'),
    name: 'AdminRecord',
    meta: {
      title: '作品日志',
      icon: 'rizhi'
    }
  }, {
    path: 'welcome',
    component: () => import('@/views/admin/welcome'),
    name: 'AdminWelcome',
    meta: {
      title: '欢迎',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'rewards',
    component: () => import('@/views/admin/rewards'),
    name: 'AdminRewards',
    meta: {
      title: '奖项',
      icon: 'mamaniandujiangxiang'
    }
  }, {
    path: 'rewardsLog',
    component: () => import('@/views/admin/rewardsLog'),
    name: 'AdminRewardsLog',
    meta: {
      title: '奖项日志',
      icon: 'rizhi'
    }
  }, {
    path: 'winnerService',
    component: () => import('@/views/admin/winnerService'),
    name: 'AdminWinnerService',
    meta: {
      title: '获奖者服务',
      icon: 'rizhi'
    }
  }, {
    path: 'users',
    component: () => import('@/views/admin/users'),
    name: 'AdminUsers',
    meta: {
      title: '用户',
      icon: 'yonghu'
    }
  }, {
    path: 'userLog',
    component: () => import('@/views/admin/userLog'),
    name: 'AdminUserLog',
    meta: {
      title: '用户日志',
      icon: 'rizhi'
    }
  },
  // {
  //   path: 'document',
  //   component: () => import('@/views/user/document'),
  //   name: 'AdminDocument',
  //   meta: {
  //     title: '相关文档',
  //     icon: 'xinxi'
  //   }
  // },
  {
    path: 'message',
    component: () => import('@/views/admin/message'),
    name: 'AdminMessage',
    meta: {
      title: '通知群发',
      icon: 'qunfaxinxi'
    }
  }, {
    path: 'password',
    component: () => import('@/views/admin/password'),
    name: 'AdminPassword',
    meta: {
      title: '更改密码'
    }
  },
  // 初筛相关路由
  {
    path: 'initialScreening',
    component: () => import('@/views/admin/initialScreening'),
    name: 'AdminInitialScreening',
    meta: {
      title: '初筛',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'initialScreeningList',
    component: () => import('@/views/admin/initialScreening/list'),
    name: 'AdminInitialScreeningList',
    meta: {
      title: '初筛-作品列表',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'initialScreeningDetail',
    component: () => import('@/views/admin/initialScreening/detail'),
    name: 'AdminInitialScreeningDetail',
    meta: {
      title: '初筛-作品详情',
      icon: 'cansaizuopin'
    }
  },
  // 初审相关路由（原初评改为初审）
  {
    path: 'initialReview',
    component: () => import('@/views/admin/initialReview'),
    name: 'AdminInitialReview',
    meta: {
      title: '初审',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'initialReviewList',
    component: () => import('@/views/admin/initialReview/list'),
    name: 'AdminInitialReviewList',
    meta: {
      title: '初审-作品列表',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'initialReviewDetail',
    component: () => import('@/views/admin/initialReview/detail'),
    name: 'AdminInitialReviewDetail',
    meta: {
      title: '初审-作品详情',
      icon: 'cansaizuopin'
    }
  },
  // 复评相关路由
  {
    path: 'reReview',
    component: () => import('@/views/admin/reReview'),
    name: 'AdminReReview',
    meta: {
      title: '复评',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'reReviewList',
    component: () => import('@/views/admin/reReview/list'),
    name: 'AdminReReviewList',
    meta: {
      title: '复评-作品列表',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'reReviewDetail',
    component: () => import('@/views/admin/reReview/detail'),
    name: 'AdminReReviewDetail',
    meta: {
      title: '复评-作品详情',
      icon: 'cansaizuopin'
    }
  },
  // 终评作品相关路由
  {
    path: 'finalReview',
    component: () => import('@/views/admin/reReview'),
    name: 'AdminFinalReview',
    meta: {
      title: '终评作品',
      icon: 'cansaizuopin',
      readonly: true
    }
  }, {
    path: 'finalReviewList',
    component: () => import('@/views/admin/reReview/list'),
    name: 'AdminFinalReviewList',
    meta: {
      title: '终评作品-作品列表',
      icon: 'cansaizuopin',
      readonly: true
    }
  }, {
    path: 'finalReviewDetail',
    component: () => import('@/views/admin/reReview/detail'),
    name: 'AdminFinalReviewDetail',
    meta: {
      title: '终评作品-作品详情',
      icon: 'cansaizuopin',
      readonly: true
    }
  },
  // 保留原有的初评相关路由作为兼容
  {
    path: 'judge',
    component: () => import('@/views/admin/judge'),
    name: 'AdminJudge',
    meta: {
      title: '初评',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'judgeList',
    component: () => import('@/views/admin/judge/list'),
    name: 'AdminJudgeList',
    meta: {
      title: '初评-作品列表',
      icon: 'cansaizuopin'
    }
  }, {
    path: 'judgeDetail',
    component: () => import('@/views/admin/judge/detail'),
    name: 'AdminJudgeDetail',
    meta: {
      title: '初评-作品',
      icon: 'cansaizuopin'
    }
  },
  {
    path: 'judgeScore',
    component: () => import('@/views/admin/judgeScore/detail'),
    name: 'AdminJudgeScore',
    meta: {
      title: '初评评分表',
      icon: 'cansaizuopin',
      requiredRoles: [5]
    }
  },
  // {
  //   path: 'judgeScoreDetail',
  //   component: () => import('@/views/admin/judgeScore/detail'),
  //   name: 'AdminJudgeScoreDetail',
  //   meta: {
  //     title: '初评整体评分-详情',
  //     icon: 'cansaizuopin'
  //   }
  // },
  {
    path: 'judgeResult',
    component: () => import('@/views/admin/judgeResult'),
    name: 'AdminJudgeResult',
    meta: {
      title: '初评结果',
      icon: 'cansaizuopin'
    }
  },
  // {
  //   path: 'judgeRe',
  //   component: () => import('@/views/admin/judgeRe'),
  //   name: 'AdminJudgeRe',
  //   meta: {
  //     title: '复评',
  //     icon: 'cansaizuopin'
  //   }
  // }, {
  //   path: 'judgeReList',
  //   component: () => import('@/views/admin/judgeRe/list'),
  //   name: 'AdminJudgeReList',
  //   meta: {
  //     title: '复评-作品列表',
  //     icon: 'cansaizuopin'
  //   }
  // }, {
  //   path: 'judgeReDetail',
  //   component: () => import('@/views/admin/judgeRe/detail'),
  //   name: 'AdminJudgeReDetail',
  //   meta: {
  //     title: '复评-作品',
  //     icon: 'cansaizuopin'
  //   }
  // },
  // {
  //   path: 'judgeReScore',
  //   component: () => import('@/views/admin/judgeReScore'),
  //   name: 'AdminJudgeReScore',
  //   meta: {
  //     title: '复评整体评分',
  //     icon: 'cansaizuopin'
  //   }
  // },
  {
    path: 'judgeReScore',
    component: () => import('@/views/admin/judgeReScore/detail'),
    name: 'AdminJudgeReScore',
    meta: {
      title: '复评整体评分',
      icon: 'cansaizuopin'
    }
  }
  // {
  //   path: 'judgeReResult',
  //   component: () => import('@/views/admin/judgeReResult'),
  //   name: 'AdminJudgeReResult',
  //   meta: {
  //     title: '复评结果',
  //     icon: 'cansaizuopin'
  //   }
  // }
  ]
}

export default adminRouter
